// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_GVA","cls2":"ProfilePdfPackCard-cls2_kZU ProfilePdfPackCard-cls1_GVA"};